import ReactGA from 'react-ga4';

/**
 * Triggers a Google Analytics event.
 * @param {GoogleAnalyticsEvent} event
 */
export const trackAnalyticsEvent = event => {
  ReactGA.event(event);
};

/**
 * @typedef {import('react-ga4/types/ga4').UaEventOptions} GoogleAnalyticsEvent
 */